/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-external-order-item.reducer';

export const PharmacyExternalOrderItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyExternalOrderItemEntity = useAppSelector(state => state.pharmacyExternalOrderItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyExternalOrderItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.detail.title">PharmacyExternalOrderItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.id}</dd>
          <dt>
            <span id="itemStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.itemStatus">Item Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.itemStatus}</dd>
          <dt>
            <span id="orderedQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.orderedQty">Ordered Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.orderedQty}</dd>
          <dt>
            <span id="fulfilledQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.fulfilledQty">Fulfilled Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.fulfilledQty}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.packs}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.productType}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.productId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.order">Order</Translate>
          </dt>
          <dd>{pharmacyExternalOrderItemEntity.order ? pharmacyExternalOrderItemEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-external-order-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-external-order-item/${pharmacyExternalOrderItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyExternalOrderItemDetail;
